import React from 'react';
import { cn } from '../../utils/cn';
import ChatAttachments from './ChatAttachments';
import PendingAttachment from './PendingAttachment';

const chatTimeFormatter = new Intl.DateTimeFormat('ru-RU', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

function formatMessageTime(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return String(iso);
  return chatTimeFormatter.format(date);
}

const roleClassName = {
  user: 'ml-8 rounded-2xl bg-orange-50 px-3 py-2 text-gray-900',
  operator: 'mr-8 rounded-2xl bg-gray-100 px-3 py-2 text-gray-900',
  system: 'mx-4 rounded-xl bg-gray-200 px-3 py-2 text-sm text-gray-700 text-center',
};

const ChatMessage = ({ message }) => {
  const className = roleClassName[message.sender_role] || roleClassName.system;

  return (
    <div className={cn(className, message.pending && 'opacity-60')}>
      {message.body ? <div className="whitespace-pre-wrap break-words">{message.body}</div> : null}
      {message.pendingFile ? <PendingAttachment file={message.pendingFile} /> : <ChatAttachments attachments={message.attachments} />}
      <div className="text-xs text-gray-500 mt-1">{message.pending ? 'Отправка…' : formatMessageTime(message.created_at)}</div>
    </div>
  );
};

export default ChatMessage;
